import { loadingAnimation } from 'components/Loader/styled'
import { lighten } from 'polished'
import styled from 'styled-components/macro'

/* Loading state bubbles (animation style from: src/components/Loader/styled.tsx) */
export const LoadingBubble = styled.div<{
  height?: string
  width?: string
  round?: boolean
  delay?: string
  margin?: string
}>`
  border-radius: 12px;
  border-radius: ${({ round }) => (round ? '50%' : '12px')};
  ${({ margin }) => margin && `margin: ${margin}`};
  height: ${({ height }) => height ?? '24px'};
  width: 50%;
  width: ${({ width }) => width ?? '50%'};
  animation: ${loadingAnimation} 1.5s infinite;
  ${({ delay }) => delay && `animation-delay: ${delay};`}
  animation-fill-mode: both;
  background: linear-gradient(
    to left,
    '#000000c' 25%,
    ${({ theme }) => lighten(0.075, '#000000c')} 50%,
    ${({ theme }) => '#000000c'} 75%
  );
  will-change: background-position;
  background-size: 400%;
`
export const SmallLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '25%'};
`

export const MediumLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '65%'};
`

export const LongLoadingBubble = styled(LoadingBubble)<{
  width?: string
}>`
  width: ${({ width }) => width ?? '90%'};
`

export const IconLoadingBubble = styled(LoadingBubble)<{
  width?: string
  height?: string
}>`
  border-radius: 50%;
  width: ${({ width }) => width ?? '24px'};
  height: ${({ height }) => height ?? '24px'};
`
